import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, Loader2, User } from "lucide-react";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/admin/customers").then(({ data }) => setCustomers(data)).catch(() => setCustomers([]));
  }, []);

  const filtered = (customers || []).filter((c) =>
    !search || c.name?.toLowerCase().includes(search.toLowerCase()) || c.email?.toLowerCase().includes(search.toLowerCase()) || c.mobile?.includes(search)
  );

  return (
    <div data-testid="admin-customers-page">
      <h1 className="font-serif text-3xl lg:text-4xl text-obsidian mb-1">Customers</h1>
      <p className="text-sm text-muted-foreground mb-6">{customers?.length || 0} registered customers</p>

      <div className="relative mb-5 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input placeholder="Search customers..." value={search} onChange={(e) => setSearch(e.target.value)} className="pl-10 rounded-sm bg-white" data-testid="customer-search" />
      </div>

      {customers === null ? (
        <div className="py-16 text-center"><Loader2 className="w-6 h-6 animate-spin mx-auto text-gold" /></div>
      ) : (
        <div className="bg-white border border-black/10 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-black/10 text-left text-xs uppercase tracking-wider text-muted-foreground">
                <th className="p-4 font-semibold">Customer</th>
                <th className="p-4 font-semibold hidden sm:table-cell">Mobile</th>
                <th className="p-4 font-semibold hidden md:table-cell">Joined</th>
                <th className="p-4 font-semibold text-right">Orders</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c) => (
                <tr key={c.id} className="border-b border-black/5 last:border-0 hover:bg-secondary/40" data-testid={`customer-row`}>
                  <td className="p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 bg-obsidian text-gold flex items-center justify-center rounded-full shrink-0"><User className="w-4 h-4" /></div>
                      <div><p className="font-medium text-obsidian">{c.name}</p><p className="text-xs text-muted-foreground break-all">{c.email}</p></div>
                    </div>
                  </td>
                  <td className="p-4 hidden sm:table-cell text-muted-foreground">{c.mobile}</td>
                  <td className="p-4 hidden md:table-cell text-muted-foreground text-xs">{c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—"}</td>
                  <td className="p-4 text-right font-semibold">{c.order_count}</td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={4} className="p-12 text-center text-muted-foreground">No customers found.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
